import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/Toolbox.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: m }));
e.displayName = "ToolboxIcon";
const n = e;
export {
  n as Toolbox,
  e as ToolboxIcon
};
